import React from 'react';

import CheckBoxComponentV2 from '../checkBoxComponentV2/checkBoxComponentV2';

import './checkBoxV2WithTitleComponent.css';

const CheckBoxV2WithTitleComponent = ({
  isDisabled = false,
  isChecked = false,
  onClick = () => {},
  titleTxt = '',
  showMinusIcon,
}) => {
  return (
    <div className="et-v2-checkbox-with-title-container">
      <CheckBoxComponentV2
        isDisabled={isDisabled}
        isChecked={isChecked}
        onClick={onClick}
        showMinusIcon={showMinusIcon}
      />
      <div
        className={`et-v2-checkbox-with-title-txt ${
          isDisabled ? 'et-v2-checkbox-with-title-txt-disabled' : ''
        }`}>
        {titleTxt}
      </div>
    </div>
  );
};

export default CheckBoxV2WithTitleComponent;
